module.exports = __webpack_public_path__ + "img/designer_wait.2541bf3a.png";